<template>
  <div 
    :class="[
      `page`,
      appPage.classes,
      {
        'page--is-loaded': appState.loaded,
      },
    ]" 
    :id="`app`" 
    :data-env="appEnv">
    <ui-header />
    <template v-if="getLocalStoreLocalStoreUp">
      <!-- <home-pop-up-vue /> -->
    </template>

    <transition 
      name="loader" 
      mode="out-in" 
      @appear="onLoad()" 
      @enter="onLoad()" 
      @leave="onLeave()">
      <router-view :key="$route.fullPath" />
    </transition>

    <ui-footer-legal v-if="!$route.meta.hideFooter" :footer="footer" />

    <ui-loader />



  </div>
</template>

<style lang="scss">
@import '../assets/main.scss';
</style>

<script>


// Config
import config, { env } from 'config';


// Vuex
import { mapGetters, mapActions } from 'vuex';

import footer from 'models/global/Footer';

import UiFooterLegal from 'components/Footer';

// Ui
import UiHeader from 'components/Header';
import UiLoader from 'components/Loader';



// Export
export default {
  name: 'app',

  // Meta info
  metaInfo() {
    return {
      titleTemplate(titleChunk) {
        return `${env !== 'prod' ? `[${env}] ` : ''}${titleChunk ? `${titleChunk}${config.meta.separator}` : ''}${this.org.program_name || config.name}`;
      },
      htmlAttrs: {
        prefix: 'og: http://ogp.me/ns#',
      },
      changed(metaInfo/*, added, removed*/) {
        if (metaInfo.title !== this.metaTitle && this.updateMetaTitle) {
          this.updateMetaTitle(metaInfo.title);
        }

        if (this.$route.name && metaInfo.titleChunk) {
          document.dispatchEvent(new Event('custom-post-render-event'));
        }

        if (this.updateMeta) {
          this.updateMeta(metaInfo);
        }
      },
    };
  },

  // Components
  components: {
    UiHeader,
    UiLoader,
    UiFooterLegal,
  },

  data() {
    return {
      footer,
    };
  },

  // Data
  computed: {
    ...mapGetters('meta', [
      'metaTitle',
    ]),
    ...mapGetters('app', [
      'org',
      'appEnv',
      'appState',
      'appPage',
    ]),
  },

  // Methods
  methods: {
    ...mapActions('app', [
      'openLoader',
      'updatePage',
      'updateViewport',
      'setTouch',
      'requestOrg',
    ]),
    ...mapActions('meta', [
      'updateMeta',
      'updateMetaTitle',
    ]),
    onLeave() {
      this.openLoader();
    },

    onLoad() {
      this.updatePage();
    },
    OnLoadPopUp() {
      const getLogOff = localStorage.getItem('setHomePopUp');
      if (getLogOff === 'false') {
        this.getLocalStoreLocalStoreUp = false;
      }
    },
  },

  // Lifecycle
  created() {
    if (localStorage.getItem('forcedLogout')) {
      localStorage.removeItem('forcedLogout');
    }
    this.updateViewport();
    this.setTouch();
    this.requestOrg();
    window.addEventListener('resize', () => this.updateViewport(), true);

  },

  mounted() {
    this.OnLoadPopUp();
  },
  destroyed() {
    window.removeEventListener('resize', () => this.updateViewport(), true);
  },
};
</script>



// WEBPACK FOOTER //
// App.vue?f6e8a03c